import { useState } from 'react'
import { TextField, Button, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import ApplicationsApi from '../../../services/applications'

const ContractInfoForm = ({ application, apartment }) => {
    const { t } = useTranslation()
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        postalArea: '',
        postalCode: '',
        idNumber: '',
        phone: '',
        applicationCode: '',
        email: '',
    })

    const [errors, setErrors] = useState({})

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value,
        })
        setErrors({
            ...errors,
            [name]: '', // Clear error for the current field
        })
    }

    const validateForm = () => {
        const newErrors = {}
        if (!formData.name.trim()) newErrors.name = t('validation.required')
        if (!formData.idNumber.trim()) newErrors.idNumber = t('validation.required')
        if (!formData.phone.trim()) {
            newErrors.phone = t('validation.required')
        } else if (!/^[\d+]+$/.test(formData.phone.trim())) {
            newErrors.phone = t('validation.invalidPhoneNumber')  // Replace with your custom error message for invalid phone
        }
        if (!formData.email.trim()) {
            newErrors.email = t('validation.required')
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = t('validation.invalidEmail')
        }
        if (!formData.address.trim()) newErrors.address = t('validation.required')
        if (!formData.postalCode.trim()) newErrors.postalCode = t('validation.required')
        if (!formData.postalArea.trim()) newErrors.postalArea = t('validation.required')

        return newErrors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm()
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors)
            return
        }

        try {
            const { applicationId } = application || {}
            const { apartmentId } = apartment || {}

            const payload = {
                ...formData,
                applicationCode: application.code,
            }

            const response = await ApplicationsApi.addContractInformation(apartmentId, applicationId, payload)
            console.log(response);

            if (response.status === 200) {
                window.location.reload()
            } else {
                alert(`Error: ${response.message || 'Something went wrong'}`)
            }
        } catch (error) {
            alert(`Something went wrong: ${error.message}`)
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.name')}
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        error={!!errors.name}
                        helperText={errors.name}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.idNumber')}
                        name="idNumber"
                        value={formData.idNumber}
                        onChange={handleChange}
                        error={!!errors.idNumber}
                        helperText={errors.idNumber}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.phone')}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        error={!!errors.phone}
                        helperText={errors.phone}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.email')}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.address')}
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        error={!!errors.address}
                        helperText={errors.address}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.postalCode')}
                        name="postalCode"
                        value={formData.postalCode}
                        onChange={handleChange}
                        error={!!errors.postalCode}
                        helperText={errors.postalCode}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label={t('applicantCard.contractInfoForm.city')}
                        name="postalArea"
                        value={formData.postalArea}
                        onChange={handleChange}
                        error={!!errors.postalArea}
                        helperText={errors.postalArea}
                        fullWidth
                    //required
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                    >
                        {t('applicantCard.contractInfoForm.submit')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default ContractInfoForm
